import React from "react";

interface LabelProps {
  id?: string;
  text?: string;
  className?: string;
}

const Label = ({id, text}: LabelProps) => {
    return (
          <label id={id} data-testid={id} className="tw-text-[#747593] tw-text-sm tw-font-medium">{text ?? ''}</label>
    );
}

export default Label;